(() => {
  /**
   * EU withdrawal form ("Vertrag widerrufen"): validates, posts to the Oceansouth worker
   * (POST /withdrawal), then shows the recorded submission time, reference and a summary.
   * The worker emails the confirmation; the page also states that it was sent.
   */
  const root = document.getElementById("wr-root");
  if (!root) return;
  const $ = (sel) => root.querySelector(sel);
  const form = $("[data-wr-form]");
  const submitBtn = $("[data-wr-submit]");
  const errorBox = $("[data-wr-error]");
  const success = $("[data-wr-success]");
  const card = $("[data-wr-form-card]");
  const orderSelect = $("[data-wr-order-select]");
  const note = form.querySelector('[name="note"]');
  const counter = $("[data-wr-count]");
  const i18n = { error: root.dataset.wrI18nError, rate: root.dataset.wrI18nRate, required: root.dataset.wrI18nRequired, sending: root.dataset.wrI18nSending };
  const endpoint = root.dataset.wrEndpoint;

  if (note && counter) note.addEventListener("input", () => { counter.textContent = String(note.value.length); });
  if (orderSelect) orderSelect.addEventListener("change", () => {
    const opt = orderSelect.selectedOptions[0];
    if (!opt || !opt.value) return;
    form.querySelector('[name="order_number"]').value = opt.value;
    const d = form.querySelector('[name="order_date"]');
    if (d && opt.dataset.date) d.value = opt.dataset.date;
  });

  function showError(msg) { errorBox.textContent = msg; errorBox.hidden = false; errorBox.focus && errorBox.focus(); }
  function clearError() { errorBox.hidden = true; errorBox.textContent = ""; }
  function markInvalid(el, invalid) { el.setAttribute("aria-invalid", invalid ? "true" : "false"); }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearError();
    const data = Object.fromEntries(new FormData(form).entries());
    let bad = false;
    for (const key of ["name", "email", "order_number"]) {
      const el = form.querySelector(`[name="${key}"]`);
      const ok = key === "email" ? /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(el.value).trim()) : String(el.value).trim().length >= 2;
      markInvalid(el, !ok);
      if (!ok && !bad) { bad = true; el.focus(); }
    }
    if (bad) { showError(i18n.required); return; }
    if (!endpoint) { showError(i18n.error); return; }

    const original = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = i18n.sending;
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: data.name, email: data.email, order_number: data.order_number, order_date: data.order_date || "",
          note: data.note || "", website: data.website || "",
          market: root.dataset.wrMarket, locale: root.dataset.wrLocale, page_url: location.href
        })
      });
      const json = await res.json().catch(() => ({}));
      if (res.status === 429) { showError(i18n.rate); return; }
      if (!res.ok || !json.ok) { showError(i18n.error); return; }
      renderSuccess(json, data);
    } catch (err) {
      showError(i18n.error);
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = original;
    }
  });

  function renderSuccess(json, data) {
    const when = `${json.submitted_date_local}, ${json.submitted_time_local} (${json.time_zone})`;
    $("[data-wr-ref]").textContent = json.reference;
    $("[data-wr-when]").textContent = when;
    $("[data-wr-sum-name]").textContent = data.name;
    $("[data-wr-sum-email]").textContent = data.email;
    $("[data-wr-sum-order]").textContent = data.order_number + (data.order_date ? ` (${data.order_date})` : "");
    const noteRow = $("[data-wr-sum-note-row]");
    if (data.note && data.note.trim()) { $("[data-wr-sum-note]").textContent = data.note.trim(); noteRow.hidden = false; }
    $("[data-wr-success-text]").textContent = (root.dataset.wrI18nSuccess || "")
      .replace("%date%", json.submitted_date_local).replace("%time%", json.submitted_time_local).replace("%email%", data.email);
    $("[data-wr-mail-hint]").textContent = (json.confirmation_sent ? (root.dataset.wrI18nMailSent || "") : (root.dataset.wrI18nMailPending || "")).replace("%email%", data.email);
    card.hidden = true;
    success.hidden = false;
    success.scrollIntoView({ behavior: "smooth", block: "start" });
    const title = success.querySelector(".wr__success-title");
    if (title) { title.setAttribute("tabindex", "-1"); title.focus({ preventScroll: true }); }
  }
})();
